//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const UnhandledExceptionOnDatasourceDelete: FeatureFlag = {"Id":"UnhandledExceptionOnDatasourceDelete","Label":"(QA) FAIL ALL DATA SOURCE DELETES WITH A UNHANDLED EXCEPTION","Impact":"For QA. Throws an exception when deleting a data source. For testing the delete failure display","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":1};
